import Vue from 'vue'
import Router from 'vue-router'
import general from './general'

Vue.use(Router)
// 路由集合
let routers = []
//
/**
 * general 公共部分
 */
routers = routers.concat(general)
export default new Router({
  mode: 'history',
  base: '/web/',
  routes: routers
})



// WEBPACK FOOTER //
// ./src/router/index.js